import { render, staticRenderFns } from "./detailListTabel.vue?vue&type=template&id=7d7f48ca&scoped=true"
import script from "./detailListTabel.vue?vue&type=script&lang=js"
export * from "./detailListTabel.vue?vue&type=script&lang=js"
import style0 from "./detailListTabel.vue?vue&type=style&index=0&id=7d7f48ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7f48ca",
  null
  
)

export default component.exports